module.exports = __webpack_public_path__ + "img/e4.2fca25d9.png";